<template>
  <div>
    <div class="card pt-3" style="border:none">
      <div class="card-body p-1">
        <h4 class="card-title mb-3   text-dark text-uppercase" style="font-weight:700"><span
            style="color: #9ccc65">Bank</span> Agent Login</h4>
        <form @submit.prevent="login">

          <div class="mb-3">
            <label for="bankID" class="fw-bolder">
              <h5>Bank</h5>
            </label>

            <v-select id="bankID"
                      v-model="form.bank"
                      :options="banks"
                      :reduce="item=>item.id"
                      label="NameOFBank">
              <template #option="{ NameOFBank, Base64 , logo}">
                <img v-if="logo" :src="logo" width="25px" height="25px">
                {{ NameOFBank }}
              </template>

              <template #selected-option="{ NameOFBank, Base64 , logo }">
                <img v-if="logo" :src="logo" width="25px" height="25px">
                {{ NameOFBank }}
              </template>
            </v-select>
          </div>

          <div class="form-floating mb-3">
            <input type="email" class="form-control" v-model="form.email" id="username"
                   placeholder="User Name" required>
            <label for="username">Email</label>
          </div>

          <div class="form-floating mb-3">
            <input :type="passwordType" class="form-control"
                   v-model="form.password" id="password"
                   placeholder="Password" required>
            <label for="password">Password</label>
          </div>

          <label class="show-password-checkbox mb-2">
            <input type="checkbox" v-model="showPassword">
            Show Password
          </label>

          <div class="text-center submit-btns">
            <button class="btn" :disabled="loading">{{ loadingText }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "UserLogin",
  beforeMount() {
    this.$store.commit(`clearAgent`)
    this.$store.commit(`setRequestCounts`, {
      agentCount: 0,
      requestCount: 0,
    })
  },
  data() {
    return {
      showPassword: false,
      loading: false,
      form: {
        bank: null,
        password: '',
        email: '',
      }
    }
  },
  computed: {
    loadingText() {
      return this.loading ? `Logging In ...` : `Login`;
    },

    banks() {
      return this.$store.getters.getAllBanks;
    },
    passwordType() {
      return this.showPassword ? `text` : `password`;
    },
  },
  methods: {
    login() {
      this.loading = true;
      return this.$store.dispatch(`agentLogin`, this.form)
          .then(() => this.$router.push({name: `pending-requests`}))
          .finally(() => this.loading = false)

    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  background: #1e88e5;
  color: white;
  font-weight: 600;
  display: block;
  height: 45px;
  flex: 1;
}

.submit-btns {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  max-width: 400px;
  width: 95vw;
  position: relative;
}
</style>
